import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { BRAND, PROJECTS } from "../data/portfolio";

const PAGES = [
  { label: "Work", to: "/#work" },
  { label: "Services", to: "/#services" },
  { label: "About", to: "/#about" },
  { label: "FAQ", to: "/#faq" },
  { label: "Contact", to: "/#contact" },
];

const colCls = "flex flex-col gap-2.5 text-sm text-white/55";
const linkCls = "hover:text-white transition-colors";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#070707]" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <span className="font-display font-extrabold text-2xl tracking-tight">{BRAND.name}<span className="text-white/40">.</span></span>
          <p className="text-white/40 text-sm mt-1">{BRAND.role}</p>
          <p className="text-white/45 text-sm mt-5 max-w-sm leading-relaxed">
            Keynotes and websites that make brands look as good as they are. Designed in Florida, presented and launched everywhere.
          </p>
        </div>

        <nav className="md:col-span-2" aria-label="Site">
          <p className="text-xs uppercase tracking-[0.25em] text-white/35 mb-4">Site</p>
          <ul className={colCls}>
            {PAGES.map((p) => (
              <li key={p.to}><Link to={p.to} className={linkCls} data-testid={`footer-link-${p.label.toLowerCase()}`}>{p.label}</Link></li>
            ))}
          </ul>
        </nav>

        <nav className="md:col-span-3" aria-label="Selected work">
          <p className="text-xs uppercase tracking-[0.25em] text-white/35 mb-4">Selected work</p>
          <ul className={colCls}>
            {PROJECTS.map((p) => (
              <li key={p.slug}><Link to={`/work/${p.slug}`} className={linkCls} data-testid={`footer-work-${p.slug}`}>{p.title}</Link></li>
            ))}
          </ul>
        </nav>

        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] text-white/35 mb-4">Elsewhere</p>
          <ul className={colCls}>
            {BRAND.socials.map((s) => (
              <li key={s.href}>
                <a href={s.href} target="_blank" rel="noopener noreferrer" className={`${linkCls} inline-flex items-center gap-1`} data-testid={`footer-social-${s.label.toLowerCase()}`}>
                  {s.label} <ArrowUpRight size={13} />
                </a>
              </li>
            ))}
            <li><a href={`mailto:${BRAND.email}`} className={linkCls} data-testid="footer-email">{BRAND.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 pb-10">
        <p className="text-white/30 text-xs">© {new Date().getFullYear()} {BRAND.full}. All rights reserved.</p>
      </div>
    </footer>
  );
}
